import { useQuery } from 'react-query';

import { getHistoryMonitoring } from 'api/traps/Trap/getHistoryMonitoring';

export const useGetHistoryMonitoring = (slug: string, type: string, startDate?: string, endDate?: string) => {
  const { data, refetch, isLoading, isRefetching } = useQuery(
    'getHistoryMonitoring',
    () => getHistoryMonitoring(slug, type, startDate, endDate),
    {
      refetchOnWindowFocus: false,
      refetchInterval: 10000,
    },
  );

  return { data, refetch, isLoading, isRefetching };
};
